<script setup>
import { computed, onMounted } from 'vue';
import { useI18n } from 'vue-i18n';
import { useStore, useMapGetter } from 'dashboard/composables/store';

/**
 * action_params shape:
 *   [{ macro_id: Number }]
 */
const props = defineProps({
  modelValue: {
    type: [Array, Object, String],
    default: () => [],
  },
});
const emit = defineEmits(['update:modelValue']);

const { t } = useI18n();
const store = useStore();

const macros = useMapGetter('macros/getMacros');

const value = computed(() => {
  if (Array.isArray(props.modelValue) && props.modelValue[0]) {
    return props.modelValue[0];
  }
  return {};
});

const macroId = computed({
  get: () => value.value.macro_id || null,
  set: id => emit('update:modelValue', [{ macro_id: id }]),
});

onMounted(() => {
  if (!macros.value || macros.value.length === 0) {
    store.dispatch('macros/get');
  }
});
</script>

<template>
  <div class="w-full mt-2 flex flex-col gap-2">
    <div>
      <label class="text-xs text-n-slate-11 mb-1 block">
        {{ t('AUTOMATION.ACTION.MACRO_SELECT.LABEL') }}
      </label>
      <select v-model="macroId" class="m-0 w-full">
        <option :value="null" disabled>
          {{ t('AUTOMATION.ACTION.MACRO_SELECT.PLACEHOLDER') }}
        </option>
        <option v-for="macro in macros" :key="macro.id" :value="macro.id">
          {{ macro.name }}
        </option>
      </select>
      <p v-if="!macros || !macros.length" class="text-xs text-n-slate-10 mt-1">
        {{ t('AUTOMATION.ACTION.MACRO_SELECT.NO_MACROS') }}
      </p>
    </div>
  </div>
</template>
